import React from 'react'
import { Trans, withI18n, withI18nProps } from '@lingui/react'
import HeaderBox from 'client/shared/boxes/header-box'
import './code-index-layout.styl'
import Spacer from 'client/shared/blocks/spacer/spacer'
import { Heading } from 'client/shared/blocks/heading/heading'
import { Locale } from 'client/shared/types/current-user'
import ArrowIcon from 'client/shared/icons/arrow-right-m.svg'
import AIcon from 'client/shared/icons/a.svg'
import ComicsIcon from 'client/shared/icons/comics.svg'
import NoteIcon from 'client/shared/icons/note.svg'
import SVGInline from 'react-svg-inline'
import Linka from 'client/shared/blocks/linka/linka'
import urlHelper from 'shared/tools/url-helper'
import HorizontalScroller from 'client/shared/blocks/horizontal-scroller/horizontal-scroller'
import { Details } from 'client/shared/blocks/details/details'
import { Dispatch } from 'shared/types/redux'
import {
  LibraryParams,
  getBestsellers,
} from '../manage-subscriptions/retention-offer'
import { BookProps } from 'client/shared/types/book'
import { AudiobookProps } from 'client/shared/types/audiobook'
import { Loader } from 'client/shared/blocks/loader/loader'
import { BookCover } from 'client/shared/blocks/book-cover/book-cover'
import AudiobookCover from 'client/shared/blocks/audiobook-cover/audiobook-cover'
import { isLatAmCountry } from 'shared/tools/country-helpers'
import { DATA, BESTSELLER_AUDIO_IDS, GHANA_TEXTS } from './assets'
import CloseIcon from 'client/shared/icons/close.svg'

type Props = {
  handleForm: (e: React.SyntheticEvent<HTMLFormElement>) => void
  handleInput: (e: React.SyntheticEvent<HTMLInputElement>) => void
  locale: Locale
  isMobile: boolean
  booksParams?: LibraryParams
  audiobooksParams?: LibraryParams
  dispatch: Dispatch
  country: string
  resources: {
    books: BookProps[]
    audiobooks?: AudiobookProps[]
  }
  code: {
    codeValue: string
    autocomplete: boolean
    loading: boolean
    error: string | null | undefined
  }
  disabled: boolean
} & withI18nProps

const Decor: React.FC<{ locale: Locale }> = ({ locale }) => {
  const decorData = DATA[locale] || DATA.en
  const hasData = Object.keys(DATA).includes(locale)
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <HorizontalScroller>
      {['first', 'second', 'third', 'fourth'].map((item, index) => (
        <div key={`${index}-${item}`} className={`code-item ${item}`}>
          <img
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            src={`${ASSETS_PATH}code-page/${
              hasData ? locale : 'en'
            }/photo-${index}.png`}
            alt=""
          />
          <Spacer />
          <div className={`book-item ${item}`}>
            <Linka
              target="_blank"
              path={urlHelper.resource(
                decorData[index].bookUuid,
                decorData[index].type,
              )}
            >
              <img
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                src={`${ASSETS_PATH}code-page/${
                  hasData ? locale : 'en'
                }/cover-${index}.png`}
                alt=""
              />
            </Linka>
            <div>
              <span>
                <Linka
                  target="_blank"
                  path={urlHelper.author(decorData[index].bookAuthorUuid)}
                >
                  {decorData[index].bookAuthor}
                </Linka>
              </span>
              <br />
              <b>
                <Linka
                  target="_blank"
                  path={urlHelper.resource(
                    decorData[index].bookUuid,
                    decorData[index].type,
                  )}
                >
                  {decorData[index].bookTitle}
                </Linka>
              </b>
            </div>
          </div>
        </div>
      ))}
    </HorizontalScroller>
  )
}

class _CodeLayout extends React.Component<Props> {
  async componentDidUpdate(prevProps): Promise<void> {
    if (
      !prevProps.booksParams &&
      this.props.booksParams &&
      !this.props.resources?.books?.length
    ) {
      const { locale, dispatch, booksParams, audiobooksParams } = this.props

      getBestsellers({
        dispatch,
        locale,
        libraryParams: booksParams as LibraryParams,
        append: true,
      })
      getBestsellers({
        dispatch,
        locale,
        libraryParams: audiobooksParams as LibraryParams,
        ids: BESTSELLER_AUDIO_IDS,
      })
    }
  }
  render(): JSX.Element {
    const {
      handleForm,
      handleInput,
      disabled,
      locale,
      code,
      i18n,
      resources,
      isMobile,
      country,
    } = this.props
    const placeholder = i18n.t`code.enter_promocode`
    const isGhana = country === 'gh'
    let _locale = locale
    if (isLatAmCountry(country)) _locale = 'es'
    const hasData = Object.keys(DATA).includes(locale)

    return (
      <div className="code-layout">
        <HeaderBox />
        <Heading kind="kazimir" centered className="code__heading">
          <Trans id="code.code_heading" />
        </Heading>
        <Spacer />
        <p className="code__lead-in">
          {isGhana ? (
            GHANA_TEXTS.code_description
          ) : (
            <Trans id="code.code_description" />
          )}
        </p>
        <Spacer size={32} />
        <form onSubmit={handleForm} className="code__form">
          <input
            onChange={handleInput}
            className={`code__input ${code.error ? 'error' : 'ok'}`}
            value={code.codeValue}
            placeholder={placeholder}
          />
          <button
            className={`code__input-button ${
              code.error ? 'error-icon' : 'ok-icon'
            }`}
            disabled={disabled}
          >
            <SVGInline svg={code.error ? CloseIcon : ArrowIcon} />
          </button>
        </form>
        {code.error && (
          <>
            <Spacer />
            <div className="input__error">{code.error}</div>
          </>
        )}
        <Spacer size={isMobile ? 40 : 180} />
        <Decor locale={_locale} />
        <Spacer size={isMobile ? 40 : 180} />
        <section className="section_promo">
          <Heading rank={2} centered className="how-to-promo">
            <Trans id="code.how_to_promo" />
          </Heading>
          <Spacer size={isMobile ? 32 : 64} />
          <div className="how-to-promo_items">
            {[1, 2, 3].map(item => (
              <div className="how-to-promo_item" key={item}>
                <span className="marked-point">{item}</span>
                <span className="text-point">
                  <Trans id={`code.how_to_promo_${item}`} />
                </span>
                <Spacer />
              </div>
            ))}
          </div>
        </section>
        <Spacer size={isMobile ? 40 : 180} />
        <section className="what-is-bookmate">
          <img
            /* @ts-ignore */
            src={`${ASSETS_PATH}code-page/${
              hasData ? locale : 'en'
            }/bottom.png`}
            alt=""
          />
          <div className="what-is-bookmate_col">
            <Heading rank={3}>
              <Trans id="code.what_is_bookmate" />
            </Heading>
            <Spacer size={32} />
            <p>
              <Trans id="code.what_is_bookmate_desc" />
            </p>
          </div>
        </section>
        {resources?.books?.length ? (
          <section>
            <Spacer size={isMobile ? 24 : 120} />
            <Heading rank={4} className="scroller-heading">
              <Trans id="code.read_books" values={{ number: '200 000' }} />
            </Heading>
            <Spacer size={isMobile ? 20 : 40} />
            {/* @ts-ignore */}
            <HorizontalScroller className="scroller_books">
              {resources?.books?.map(book => (
                <>
                  <Linka
                    target="_blank"
                    path={urlHelper.resource(
                      book.uuid,
                      book.type?.toLocaleLowerCase() as string,
                    )}
                  >
                    <BookCover isLeadCover book={book} size={208} />
                  </Linka>
                  <Spacer size={isMobile ? 8 : 20} />
                  <div className="about-item">
                    {book.authors_objects?.map((author, index) => (
                      <>
                        <Linka
                          target="_blank"
                          key={author.uuid}
                          className="resource-author"
                          path={urlHelper.author(author.uuid)}
                        >
                          {author.name}
                        </Linka>
                        {index < Number(book.authors_objects?.length) - 1
                          ? ', '
                          : ''}
                      </>
                    ))}
                    <br />
                    <b>
                      <Linka
                        target="_blank"
                        className="resource-title"
                        path={urlHelper.resource(
                          book.uuid,
                          book.type?.toLocaleLowerCase() as string,
                        )}
                      >
                        {book.title}
                      </Linka>
                    </b>
                  </div>
                </>
              ))}
            </HorizontalScroller>
            <Spacer size={isMobile ? 24 : 80} />
            {resources?.audiobooks?.length && (
              <>
                <Heading rank={4} className="scroller-heading">
                  <Trans
                    id="code.read_audiobooks"
                    values={{ number: '100 000' }}
                  />
                </Heading>
                <Spacer size={isMobile ? 20 : 40} />
                {/* @ts-ignore */}
                <HorizontalScroller className="scroller_audiobooks">
                  {resources?.audiobooks?.map(audiobook => (
                    <>
                      <Linka
                        target="_blank"
                        path={urlHelper.audioBook(audiobook.uuid)}
                      >
                        <AudiobookCover
                          isLeadCover
                          audiobook={audiobook}
                          size={176}
                        />
                      </Linka>
                      <Spacer size={isMobile ? 8 : 20} />
                      <div className="about-item">
                        {audiobook.authors?.map((author, index) => (
                          <>
                            <Linka
                              target="_blank"
                              key={author.uuid}
                              className="resource-author"
                              path={urlHelper.author(author.uuid)}
                            >
                              {author.name}
                            </Linka>
                            {index < Number(audiobook.authors?.length) - 1
                              ? ', '
                              : ''}
                          </>
                        ))}
                        <br />
                        <b>
                          <Linka
                            target="_blank"
                            className="resource-title"
                            path={urlHelper.audioBook(audiobook.uuid)}
                          >
                            {audiobook.title}
                          </Linka>
                        </b>
                      </div>
                    </>
                  ))}
                </HorizontalScroller>
              </>
            )}
            <Spacer size={isMobile ? 80 : 140} />
          </section>
        ) : (
          <>
            <Spacer size={40} />
            <Loader centered />
            <Spacer size={40} />
          </>
        )}
        <section className="ad-section">
          <div className="icons-section">
            <SVGInline className="note-icon" svg={NoteIcon} />
            <SVGInline className="a-icon" svg={AIcon} />
            <SVGInline className="comics-icon" svg={ComicsIcon} />
          </div>
          <div className="ad-text-section">
            <Heading className="ad-heading" rank={6}>
              <Trans id="code.read_ad" />
            </Heading>
            <p>
              <Trans id="code.read_ad_desc" />
            </p>
          </div>
        </section>
        <Spacer size={isMobile ? 40 : 120} />
        <Heading className="faq-heading" centered rank={3}>
          <Trans id="code.frequently_asked_questions" />
        </Heading>
        <Spacer size={isMobile ? 24 : 80} />
        {[1, 2, 3, 4, 5].map((item, index) => (
          <Details
            key={`details:${index}-${item}`}
            element={{
              heading: `code_faq_${item}`,
              content: isGhana
                ? GHANA_TEXTS[`code_faq_${item}_desc`]
                : `code_faq_${item}_desc`,
              components: [<br />],
            }}
            textAsString={isGhana}
            namespace="code"
          />
        ))}
        <Spacer size={180} />
      </div>
    )
  }
}

export const CodeLayout = withI18n({ update: true })(_CodeLayout)
